import Layout from "../../layout/index";
import "react-tabs/style/react-tabs.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useNavigate } from "react-router-dom";
import Notification from "../../components/notification";
import React, { useCallback, useEffect, useState } from "react";
import Header from "../../layout/header/Header";
import {
  useDeleteAssignmentMutation,
  useEditAssignmentMutation,
  useGetAllAssignmentsMutation,
} from "../../services/assignmentModule";
import { showError, showToast } from "../../constants/toast";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import Loader from "../../constants/Loader";
import { Box, Typography } from "@mui/material";
import Pagination from "../../components/pagination";
import moment from "moment";
import { FolderListComponent } from "../../components/folderList";
import { useDeleteArticleMutation } from "../../services/article";
import { DeleteModal } from "../../components/deleteModal";
import { RenameModal } from "../../components/renameModal";
import useTranslation from "../../hooks/Translation";

const AssignmentSolutions = () => {
  const navigate = useNavigate();
  const goProfile = () => {
    navigate("/setting");
  };
  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const handleClose1 = () => setOpen1(false);
  const [sidebar, setSidebar] = useState(true);
  const [getAllHistory] = useGetAllAssignmentsMutation();
  const [historyData, setHistoryData] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const totalPages = Math.ceil(totalCount / 20);
  const translate = useTranslation();
  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const fetchHistory = async () => {
    setIsLoading(true);
    const body = {
      length: 20,
      start: page,
      search: "",
    };
    try {
      let encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const res = await getAllHistory(encryptedBody).unwrap();
      setIsLoading(false);
      if (res?.status === 200) {
        setHistoryData(res?.data?.response_object);
        setTotalCount(res?.data?.total_records);
      }
    } catch (error: any) {
      setIsLoading(false);
      showError(
        error?.message ||
          translate.errors.somethingWentWrong ||
          "Something went wrong"
      );
    }
  };

  useEffect(() => {
    fetchHistory();
  }, [page]);
  const [renameValue, setRenameValue] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [deleteData] = useDeleteAssignmentMutation();
  const [editData] = useEditAssignmentMutation();
  const [selectedId, setSelectedId] = useState(0);
  const toggleDelete = (id: number) => {
    setOpenDelete(true);
    setSelectedId(id);
  };
  const handleDelete = async (e: any) => {
    e.stopPropagation();
    try {
      const response = await deleteData({ id: selectedId }).unwrap();
      if (response.status == 200) {
        showToast(
          translate.toastMessages.assignmentDeletedSuccessfully ||
            "Assignment Deleted Successfully"
        );
        setOpenDelete(false);
      }
    } catch (error: any) {
      console.log(error);
      showError(
        error?.data?.message ||
          translate.errors.somethingWentWrong ||
          "Something went wrong"
      );
    } finally {
      await fetchHistory();
    }
  };
  const toggleEdit = (id: number, text: any) => {
    setOpenEdit(true);
    setRenameValue(text);
    setSelectedId(id);
  };
  const handleEdit = async (e: any) => {
    e.stopPropagation();
    try {
      const response = await editData({
        id: selectedId,
        body: { file_name: renameValue },
      }).unwrap();
      if (response.status == 200) {
        showToast(
          translate.toastMessages.assignmentNameUpdatedSuccessfully ||
            "Assignment name updated Successfully"
        );
        setOpenEdit(false);
        setRenameValue("");
      }
    } catch (error: any) {
      console.log(error);
      showError(
        error?.data?.message ||
          translate.errors.somethingWentWrong ||
          "Something went wrong"
      );
    } finally {
      await fetchHistory();
    }
  };
  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (
  //       window.innerHeight + document.documentElement.scrollTop >=
  //       document.documentElement.offsetHeight - 2
  //     ) {
  //       if (hasMore && !isLoading) {
  //         setPage((prevPage) => prevPage + 1);
  //       }
  //     }
  //   };

  //   window.addEventListener('scroll', handleScroll);
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, [hasMore, isLoading]);

  return (
    <>
      <Loader isLoad={isLoading} />
      <div className="sde_br_mn">
        <div className="sde_mn_cnt">
          <button
            className="btnn btn_border"
            onClick={() => navigate("/assign-solution")}
          >
            <i className="fa-regular fa-plus"></i>
            {translate.assignmentSolution.getNewSolution}
          </button>
          <Tabs>
            <TabList>
              <Tab>{translate.assignmentSolution.myPastSolutions}</Tab>
              {/* <Tab onClick={() => navigate("/assign-solution")}>Get a new Solution</Tab> */}
            </TabList>
            <TabPanel>
              <ul className="tst_lst" style={{ cursor: "pointer" }}>
                {historyData?.length ? (
                  historyData.map((item, i) => {
                    return (
                      <FolderListComponent
                        dataName={item?.file_name}
                        dataCreatedAt={item?.created_at}
                        index={i}
                        key={i}
                        nextPage={`/edit-assign/${item?.id}`}
                        handleDelete={(e: any) => {
                          e.stopPropagation();
                          toggleDelete(item?.id);
                        }}
                        handleEdit={(e: any) => {
                          e.stopPropagation();
                          toggleEdit(item?.id, item?.file_name || "");
                        }}
                        isEdit={true}
                      />
                      // <li onClick={() => navigate(`/edit-assign/${item?.id}`)} >
                      //   <h3 className='txt_rght'>Assignment {i + 1}</h3>
                      //   <p className="mt_20">{moment(item?.created_at).format('DD/MM/YYYY')}</p>

                      // </li>
                    );
                  })
                ) : (
                  <div
                    style={{
                      height: "85px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      marginTop: "15%",
                    }}
                  >
                    {" "}
                    <h3 style={{ fontSize: "xxx-large", color: "darkgrey" }}>
                      {translate.global.noRecordsFound}
                    </h3>
                  </div>
                )}
              </ul>
            </TabPanel>
            <TabPanel></TabPanel>
          </Tabs>
        </div>
      </div>
      <Notification
        open={open1}
        setOpen={setOpen1}
        handleClose={handleClose1}
      />
      <Pagination
        module={historyData}
        page={page}
        onPageChange={onPageChange}
        totalPages={totalPages}
      />
      <DeleteModal
        handleDelete={handleDelete}
        openDelete={openDelete}
        setOpenDelete={setOpenDelete}
        textData={"assignment"}
      />
      <RenameModal
        handleEdit={handleEdit}
        openEdit={openEdit}
        renameValue={renameValue}
        setOpenEdit={setOpenEdit}
        setRenameValue={setRenameValue}
        textData={"assignment"}
      />
    </>
  );
};

export default AssignmentSolutions;
